import React, { useState, useRef, Component, Fragment } from "react";
import Config from "../../Config";


import PlTitle from "../../elements/PlTitle";
import InputKidsMulti from "../../helpers/InputKidsMulti";
import InputCombo from "../../helpers/InputCombo";
import InputDate from "../../helpers/InputDate";
import InputText from "../../helpers/InputText";
import InputPostCode from "../../helpers/InputPostCode";
import InputNIP from "../../helpers/InputNIP";
import InputComboSubkonto from "../../helpers/InputComboSubkonto";
import InputDecimal from "../../helpers/InputDecimal";

import edit from "../../edit.png";
import trash from "../../trash.png";
import back from "../../back.png";
import FormatDecimal from "../../helpers/FormatDecimal";


import b_mt from "../../b_mt.png";
import b_pko from "../../b_pko.png";
import b_bp2 from "../../b_bp2.png";
import b_mbank from "../../b_mbank.png";
import b_ing from "../../b_ing.png";
import b_santander from "../../b_santander.png";
import b_milenium from "../../b_milenium.png";
import b_cg from "../../b_cg.png";
import b_sgb from "../../b_sgb.png";
import b_pariba from "../../b_pariba.png";
import b_bp3 from "../../b_bp3.png";
import b_alior from "../../b_alior.png";
import InputUploader from "../../helpers/InputUploader";


function TransferBank(props)
{ 
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    const [errTab, setErrTab] = useState([]);  //z info od serwera..
    const [xrow, setXRow] = useState({
        p_subkonta_id: '_x_',
        p_subkonta_id_valid: false,

        autopay: '0', //pomin autopay, 1- pokaż również autopay, 2 - pokaż tylko autopay
        zus: '1', //pomin zus, 1-  pokaż również zus, 2 - pokaż tylko zus
    });

    const [bank, setBank] = useState('_x_');
    const [crypt, setCryptFile] = useState('');
 

    const [tab, setTab] = useState(null);
    const [raport, setRaport] = useState(null);
    const [kids, setKids] = useState([]);
    const [p_bank_id, setPBankId] = useState(-1);

    const [amounts, setAmounts] = useState({});

    const [goAsync, setGoAsync] = useState(0); // nic nie rob  , 1 - go sync, 2 - w trakcie, 3 - gotowe

 

    const valChangeListener = (filedName, val, correct, msg) => { 
        //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);        
        setXRow( {...xrow, [filedName]:val,  [filedName+"_valid"]:correct  } );                 


        if(filedName == 'p_subkonta_id')
        {
            setBank('_x_');
            setKids([]);
            setPBankId(-1);
            setCryptFile('');
            setTab(null);
        }
    }


    //zaladuj "actual_state" - asychronicznie..
    const loadAsync = () => {

        console.log("loadAsync - start " + tab.length);        
      


        const goNextNum = (num) => {

            console.log("T: " + num );

            if( tab[num] == undefined) 
            {
                console.log("T:undef " + num);
                return;
            }

             if( tab[num].async_dz > 0 ) 
             {
                           
                            valChangeListenerD(num+"",  tab[num].async_dz, true, "" , () => {

                             

                            if(num < tab.length)
                                {
                                    setTimeout(()=>{
                                        goNextNum(num +1);
                                    }, 150);            
                                }else 
                                {
                                     console.log("T: tab finish" );
                                }


                        } );


            }else 
            {
                console.log("T:nokidid " + num);
                     setTimeout(()=>{
                                        goNextNum(num +1);
                                    }, 150);   
            }

        };
       
  
        goNextNum(0);


    }


    const sumSugerowane = (tabPoz) => {

        var sum = 0.0;

        for(var inx = 0 ; inx < tabPoz.length; inx++ )
        {          
                    for(var k=0; k < tabPoz[inx].dzieci.length; k++)
                    {        
                            sum = parseFloat(sum)  + parseFloat( tabPoz[inx].dzieci[k].suma_sugerowana_kwota	);
                    }
        }
       
        return parseFloat(sum);
    }


    const valChangeListenerD = (filedName, val, correct, msg, callBack) => { 


        var tabInx = parseInt(filedName);        

        var tmpx = tab;


        var tytul = tmpx[tabInx]["tytul"];
        var kwota = tmpx[tabInx]["kwota"];

        tmpx[tabInx]["p_dziecko_id"] = val;
        setTab(   JSON.parse(  JSON.stringify(tmpx) )  );


        if(val < 1)
        {
            var tmpx = tab;
            tmpx[tabInx]["pozycje"] = [];


            console.log("T: val -1 " + filedName);

            setTab(   JSON.parse(  JSON.stringify(tmpx) )  );

            if(callBack != null) { callBack(); }

            return;
        }



        if(val == null )      return;
        if(val == undefined ) return;
        if(val.length < 1 )   return;


        var req = {
            dzieci: [
                {
                    id: val,
                    title: '',
                }
            ],
            p_subkonta_id: xrow.p_subkonta_id,
            tytul: tytul,
            kwota: kwota,
        };

                //pobierz rodzicow i zalegle dokumenty..
                fetch( Config.url + '/rest_v1_calc,actual_state', {
                    method: 'POST', 
                    body: JSON.stringify(req), 
                    headers: {
                        'Content-Type': 'application/json',                    
                        'X-Api-Key': props.userData.apiKey,
                        '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                        '_p_dziecko_id_': props.userData.p_dziecko_id,
                        '_sec_key_': Config.genXKey() ,
                    }
                })         
                .then(res => res.json() )
                .then(res => { 

                            props.mainView.setProgress(-1);        
                            if(res._sys_ == undefined)
                            {
                                props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                            }else
                            if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                            {
                                props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                            }else    
                            {
                                props.mainView.setProgress(-1);  
                                if(res.status == 'OK') {
                                        
                                   // setRow( {...row, ['pozycje']:res.result  } ); 

                                   var tmpx = tab;
                                   tmpx[tabInx]["pozycje"] = res.result;

                                   //--podlicz sume sugerowanych..................


                                    tmpx[tabInx]["suma_sugerowanych"] = sumSugerowane(   tmpx[tabInx]["pozycje"] );
                                    console.log("Poz", "sumsug: " ,    tmpx[tabInx]["suma_sugerowanych"]  );


                                   //----------------------------------------------

                                   setTab(   JSON.parse(  JSON.stringify(tmpx) )  );

                             
                                   if(callBack != null) { callBack(); }

                                }else 
                                if(res.status == 'ERROR') {
                                    props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);   
                                    console.log("T: Error " + res.result );
                                }else 
                                {
                                     console.log("T: not ok! " );
                                }

                            }
                } )
                .catch(err => {          
                            props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                            props.mainView.setProgress(-1);
                });



    }

    const valChangeListener2 = (filedName, val, correct, msg) => {

        // var inxKey = ixRow + "_#_" + rodzic.id + "@" + dziecko.id + "@" + poz.typ + "@" + poz.typ_id; 
 
        console.log("FX", filedName, val,  parseFloat(val).toFixed(2) );

        var spRow = filedName.split('_#_');

        var rowIndex = parseInt( spRow[0] );


        var sp =   spRow[1].split("@");  //filedName.split("@");
        var rodzicId   = sp[0];
        var dzieckoId  = sp[1];
        var typ        = sp[2];
        var typId      = sp[3];

        var tmpTab = JSON.parse( JSON.stringify(tab)  );

 
        //najpierw zmien wartosc..

            //petla po rodzicach..
            for(var r=0; r < tmpTab[rowIndex].pozycje.length; r++ )
                {

                    if(tmpTab[rowIndex].pozycje[r].id != rodzicId ) continue; 

                    //petla po dzieciach..
                    for(var d=0; d<tmpTab[rowIndex].pozycje[r].dzieci.length; d++ )
                    {
                        if(tmpTab[rowIndex].pozycje[r].dzieci[d].id != dzieckoId) continue;
                       
                        //petla po zobowiazniach..
                        for(var z=0; z<tmpTab[rowIndex].pozycje[r].dzieci[d].zobowiazania.length; z++ )
                        {
                            if(  tmpTab[rowIndex].pozycje[r].dzieci[d].zobowiazania[z].typ == typ && tmpTab[rowIndex].pozycje[r].dzieci[d].zobowiazania[z].typ_id == typId )
                            {
                                tmpTab[rowIndex].pozycje[r].dzieci[d].zobowiazania[z].sugerowana_kwota = val;                 
                            }
                        }
         
                    }
                }

      //teraz podlicz...
        //petla po rodzicach..
        for(var r=0; r < tmpTab[rowIndex].pozycje.length; r++ )
        {
            //petla po dzieciach..
            for(var d=0; d<tmpTab[rowIndex].pozycje[r].dzieci.length; d++ )
            {
                var sumKw = 0.00;

                //petla po zobowiazniach..
                for(var z=0; z<tmpTab[rowIndex].pozycje[r].dzieci[d].zobowiazania.length; z++ )
                {
                        var sugKwota = tmpTab[rowIndex].pozycje[r].dzieci[d].zobowiazania[z].sugerowana_kwota;

                        if(sugKwota == null)      continue;
                        if(sugKwota == undefined) continue;
                        if(sugKwota.length < 1)   continue;

                        sumKw = parseFloat(sugKwota) + parseFloat(sumKw);
                }

                tmpTab[rowIndex].pozycje[r].dzieci[d].suma_sugerowana_kwota = sumKw;               

            }
        }

        tmpTab[rowIndex].suma_sugerowanych = sumSugerowane(  tmpTab[rowIndex].pozycje );
        console.log("PozXX", "sumsug: " ,rowIndex,   " || ",   tmpTab[rowIndex].suma_sugerowanych );

        setTab(tmpTab);

     }


    const goNextNew = () => {
        console.log("goNext");
       // saveData();
    }



    const onBack = (e) => {
        props.goBack();
    }

    const onBankSelect = (e) => {

        var t = e.target.getAttribute('atr-type');

        setBank(t);
        setKids([]);
        setPBankId(-1);
        setCryptFile('');
        setTab(null);


    }

    const onBankHover = (e) => {

        //var t = e.target.getAttribute('atr-type');

      //  setBank(t);

    }



    
    const goParse = (cr) => {
 
 
        var req = {
            crypt: cr,
            type: bank,
            p_subkonto_id: xrow.p_subkonta_id,
            zus: xrow.zus,
            autopay: xrow.autopay,
        }


        props.mainView.setProgress(-2);

    
        fetch( Config.master + '/rest_v1_calc,transfer_file', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })         
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.setProgress(-1);  
                        if(res.status == 'OK') {
                                
                            setTab(res.result);
                            setKids(res.kids);
                            setPBankId(res.p_bank_id);
                            setRaport(res.raport); 

                            if(res.async != null && res.async)
                            {
                                console.log("GoAsync - sprawdz przelewy");
                                setGoAsync(1);
                            }

                        }if(res.status == 'FILETYPE') {
                                
                            props.mainView.showDialog( "Error",  "Plik nie został rozpoznany" , "ok" , null);                               

                        }
                        if(res.status == 'ERROR') {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);   
                        }

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });

    }







    const completeUpload = (fileName, crypt) => {

        console.log("completeUpload " + fileName + " " + crypt);
        goParse(crypt);
 
    }




    const saveData = (e) => {

          //sprawdz czy laczna kwota rowna sie sumie kwot czastkowych...
          //na kazdym dodawanym przelewie


         if(tab == null )return;
         if(tab.length < 1)
         {
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Nie znaleziono żadnego przelewu' ,  "ok"  ,null); 
            return; 
         }



         //sprawdz sumy czastkowe i kwote przelewu.. 
         var ilOperacji = 0;

         for(var p=0; p < tab.length; p++)
         {
                var tytul = tab[p].tytul;
                var p_dziecko_id = tab[p].p_dziecko_id;

                var kwotaLaczna  = parseFloat( tab[p].kwota );
                var sumKwotPodanych  = parseFloat( 0.00);

                var iloscPoz = 0;



                if(p_dziecko_id < 0) continue; 

                ilOperacji++;
    
                //petla po rodzicach..
                for(var r=0; r< tab[p].pozycje.length; r++ )
                {
                    var rImie      = tab[p].pozycje[r].imie;
                    var rNazwisko  = tab[p].pozycje[r].nazwisko;

                    //petla po dzieciach..
                    for(var d=0; d < tab[p].pozycje[r].dzieci.length; d++ )
                    {
                        var dImie      = tab[p].pozycje[r].dzieci[d].imie;
                        var dNazwisko  = tab[p].pozycje[r].dzieci[d].nazwisko;

                        //petla po zobowiazaniach...
                        for(var z = 0; z < tab[p].pozycje[r].dzieci[d].zobowiazania.length; z++ )
                        {
                              var dokTyp          = tab[p].pozycje[r].dzieci[d].zobowiazania[z].typ;
                              var dokOpis          = tab[p].pozycje[r].dzieci[d].zobowiazania[z].opis;

                              //var pozostalo        =  parseFloat( tab[p].pozycje[r].dzieci[d].zobowiazania[z].pozostalo).toFixed(2) + 0.00;
                              //var sugerowana_kwota =  parseFloat( tab[p].pozycje[r].dzieci[d].zobowiazania[z].sugerowana_kwota).toFixed(2) + 0.00 ;

                              var pozostalo        =  parseFloat( tab[p].pozycje[r].dzieci[d].zobowiazania[z].pozostalo); 
                              var sugerowana_kwota =  parseFloat( tab[p].pozycje[r].dzieci[d].zobowiazania[z].sugerowana_kwota ) ;


                              console.log("Sugerowana:" , sugerowana_kwota, "Pozostalo: ", pozostalo);

                             
 

                              if(sugerowana_kwota == NaN)       continue;
                              if(isNaN(sugerowana_kwota))       continue;
                              if(sugerowana_kwota == undefined) continue;
                              if(sugerowana_kwota == null)      continue;
                              if(pozostalo == NaN)              continue;
                              if(pozostalo == undefined)        continue;
                              if(pozostalo == null)             continue;
                              if(isNaN(pozostalo) )             continue;


                              console.log( (p+1)  + ", " + dokOpis + ", " + pozostalo + ", " + sugerowana_kwota + ", " + tab[p].pozycje[r].dzieci[d].zobowiazania[z] );  



                              if(  (  (sugerowana_kwota > pozostalo  && sugerowana_kwota >0 && pozostalo > 0)    ) && dokTyp != 'none')
                              {
                                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Zbyt duża kwota rozliczenia (Pozycja / '+  parseInt( p+1)  +' / '+ rImie + ' '+ rNazwisko +' / '+ dImie + ''  + dNazwisko + ' / '+ dokOpis +'  ) [kw. roz. ' + parseFloat(sugerowana_kwota).toFixed(2) + ' większa od ' + parseFloat(pozostalo).toFixed(2) + ']' ,  "ok"  ,null); 
                                return;
                              }

                              
                             //sumKwotPodanych = parseFloat(  sugerowana_kwota ) + parseFloat (sumKwotPodanych);
                             sumKwotPodanych =   sugerowana_kwota  +  sumKwotPodanych;
                             iloscPoz = parseInt(iloscPoz) + 1;

                          
                        }

                    }
                }

                 console.log("Ilosc: " , iloscPoz,  "sumaKwotPodanych: " , parseFloat( sumKwotPodanych), "suma lacznie (przelewu): " ,  parseFloat( kwotaLaczna) );
 

                var strSumKwotPodanych =  "("+ parseFloat( sumKwotPodanych).toFixed(2) + ")";
                var strSumKwotLacznie =  "("+ parseFloat( kwotaLaczna).toFixed(2) + ")";

                if( iloscPoz != 0 &&  strSumKwotPodanych !=  strSumKwotLacznie  )
                {
                    props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Suma kwot operacji musi być równa kwocie przelewu (Pozycja / '+  parseInt( p+1)  +'  ) [ sum. cząst. ' + parseFloat( sumKwotPodanych).toFixed(2) + ' różna od ' + parseFloat( kwotaLaczna).toFixed(2)  + ' ]' ,  "ok"  ,null); 
                

                   //--------------------------------------------------------
                                var xr = {
                                    info: 'TransferBank.js',
                                    error:  'X2: Suma kwot operacji musi być równa kwocie przelewu (Pozycja / '+  parseInt( p+1)  +'  ) [ sum. cząst. ' + strSumKwotPodanych  + ' różna od ' + strSumKwotLacznie + ' ]' ,
                                };

                                fetch( Config.url + '/rest_v1,error', {
                                    method: 'POST', 
                                    body: JSON.stringify(xr), 
                                    headers: {
                                        'Content-Type': 'application/json',                    
                                        'X-Api-Key': props.userData.apiKey,
                                        '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                        '_p_dziecko_id_': props.userData.p_dziecko_id,
                                        '_sec_key_': Config.genXKey() ,
                                    }
                                })
                                .then(res => res.json() )
                                .then(res => {                                            
                                } )
                                .catch(err => {                                                    
                                });                    
                   //--------------------------------------------------------
                   return;
                }



         } //koniec petli po przelewach..




         //wyslij wszystko..
        props.mainView.setProgress(-2);


        var req = {
            p_bank_id: p_bank_id,
            p_subkonta_id: xrow.p_subkonta_id,
            rows: tab
        }
  
    
        fetch( Config.url + '/rest_v1_calc,transfer_approve', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })         
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.setProgress(-1);  
                        if(res.status == 'OK') {
                                props.mainView.showDialog( "Sukces", 'Dodano: ' + res.result, "ok" , null); 
                                props.goBack();
                        }
                        if(res.status == 'ERROR') {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);   
                        }

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });




    }



    if(tab !=null && goAsync == 1)
    {
        setGoAsync(2);
        loadAsync();
    }

   


    var title = "";

    if(bank == 'b_mt') title ="Uniwersalny format bankowy MT940";
    if(bank == 'b_pko') title ="PKO Bank Polski";
    if(bank == 'b_bp2') title ="Bank Pekao S.A.";
    if(bank == 'b_mbank') title ="MBank";
    if(bank == 'b_ing') title ="Bank ING";
    if(bank == 'b_santander') title ="Santander Bank";
    if(bank == 'b_milenium') title ="Bank Milenium";
    if(bank == 'b_cg') title ="Bank Credit Agricole";
    if(bank == 'b_sgb') title ="SGB-Bank S.A";
    if(bank == 'b_pariba') title ="BNP Paribas Bank Polska S.A.";
    if(bank == 'b_bpm') title ="Bank Pekao S.A. (przelewy masowe)";


    return <div className="view_content">

                    <img src={back} onClick={onBack} className="back_img" title="wstecz"/>

                    <h1>Import masowy przelewów bankowych</h1>

              

                    <div className="tip">
                        Pobierz ze swojego banku plik zawierający raport przeleów i załaduj go do systemu. Zalecany format <b>Mt940</b> lub <b>CSV</b>
                    </div>

                    <br/>

                            <div className="form_control">
                                    <div className="fieldName">Konto</div>
                                    <InputComboSubkonto  userData={props.userData} mainView={props.mainView}  value={xrow.p_subkonta_id} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="p_subkonta_id" placeholder={""} className='  ' req='1'   />                                    
                             </div>

                             <div className="form_control">
                                    <div className="fieldName">Płatności OnLine</div>
                                    <InputCombo items={ [{v:0,title:'Nie, pomiń (zalecane)'}, {v:1,title:'Pokaż'}, , {v:2,title:'Pokaż tylko przelewy OnLine'},   ] }  userData={props.userData} mainView={props.mainView}  value={xrow.autopay} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="autopay" placeholder={""} className='  ' req='1'   />                                    
                             </div>

                             <div className="form_control">
                                    <div className="fieldName">Przelewy z ZUS</div>
                                    <InputCombo items={ [{v:0,title:'Nie, pomiń (zalecane)'}, {v:1,title:'Pokaż'}, , {v:2,title:'Pokaż tylko z ZUS'},   ] }  userData={props.userData} mainView={props.mainView}  value={xrow.zus} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="zus" placeholder={""} className='  ' req='1'   />                                    
                             </div>

                    <br/>

                    <form className="eForm bg_center">

                                        <div className="form_control">
                                                     <div className="fieldName">Wybierz bank</div>

                                                     <div className="banks">

                                                        <img src={b_mt}  atr-type="b_mt" onClick={onBankSelect} onMouseMove={onBankHover}  />
                                                        <img src={b_pko}  atr-type="b_pko" onClick={onBankSelect} onMouseMove={onBankHover} />
                                                        <img src={b_bp2}  atr-type="b_bp2" onClick={onBankSelect} onMouseMove={onBankHover} />
                                                        <img src={b_mbank}  atr-type="b_mbank" onClick={onBankSelect} onMouseMove={onBankHover} />
                                                        <img src={b_ing}   atr-type="b_ing" onClick={onBankSelect} onMouseMove={onBankHover}/>
                                                        <img src={b_santander}  atr-type="b_santander" onClick={onBankSelect} onMouseMove={onBankHover} />
                                                        <img src={b_milenium}  atr-type="b_milenium" onClick={onBankSelect} onMouseMove={onBankHover} />
                                                        <img src={b_cg}   atr-type="b_cg" onClick={onBankSelect} onMouseMove={onBankHover} />
                                                        <img src={b_sgb}   atr-type="b_sgb" onClick={onBankSelect} onMouseMove={onBankHover} />
                                                        <img src={b_pariba}   atr-type="b_pariba" onClick={onBankSelect} onMouseMove={onBankHover} />
                                                        <img src={b_bp3}   atr-type="b_bpm" onClick={onBankSelect} onMouseMove={onBankHover} />
                                                        <img src={b_alior}   atr-type="b_alior" onClick={onBankSelect} onMouseMove={onBankHover} />

                                                    </div>   

                                        </div>


                                        <div className="form_split"></div>


                                        <div className="form_control">
                                            <h3>{title}</h3>
                                        </div>


                                      
                                        <div className="form_split"></div>

                                        {
                                            bank != '_x_' && xrow.p_subkonta_id != '_x_' && 
                                            <div className="form_control">
                                           
                                                <InputUploader   userData={props.userData}  typ="bank_rp" typId={"-1"} remove="0" completeUpload={completeUpload} title={ "-Wybierz plik-" } max_files="1" ext="*/*" />                    
                                                            
                                            </div>

                                        }

                                            <br/><br/>

                                        {
                                            raport != null &&
                                            <Fragment>
                                                <table className="">
                                                    <tr>
                                                        <td>Łacznie wszystkich znalezionych</td>
                                                        <td className="gobold goright">{raport.znalezionych}</td>
                                                        <td>Suma kwot wszystkich znalezionych</td>
                                                        <td className="gobold goright"><FormatDecimal value={raport.znalezionych_suma}/></td>
                                                    </tr>
                                                    <tr>
                                                        <td>*Łacznie wszystkich płatności OnLine (pominiętych)</td>
                                                        <td className="gobold goright">{raport.online_ilosc}</td>
                                                        <td>Suma kwot płatności OnLine</td>
                                                        <td className="gobold goright"><FormatDecimal value={raport.online_suma}/></td>
                                                    </tr>
                                                </table>
                                                <div>
                                                    *Uwaga: przelewy OnLine są ignorowane podczas importu przelewów i nie są wyświetlane w poniższej tabeli.
                                                </div>
                                                <br/>
                                            </Fragment>
                                        }



                                        {
                                            tab != null &&
                                            <div>

                                                        <table className="table" >
                                                                <thead>
                                                                    <tr className="header">                                                                                        
                                                                        <td>LP</td>                                                                                                                                                                                                                                                                                      
                                                                        <td>Tytuł</td>                                                                            
                                                                        <td>Kwota</td>                                                                                                                                                                                                                                                                  
                                                                        <td>Uznania / Obciązenia</td>                                                                                                                                                                                        
                                                                    </tr>
                                                                </thead>
                                                                <tbody>

                                                                {
                                                                    tab.map(  (row, ixRow) => {

                                                                        var css = "" ;

                                                                        if(row.p_dziecko_id > 0 ) css = "color_show2";

                                                                        if(row.status  == 1 ) css = "color_deleted2"; //istnieje

                                                                        var pozostalo = parseFloat( row.kwota) -  parseFloat(row.suma_sugerowanych);
                                                                        pozostalo = Math.round(pozostalo * 100) / 100;

                                                                        

                                                                        return <tr className={ "row " +css }>
                                                                            <td className="gocenter">{ixRow+1}</td>                                                                          
                                                                            <td className="goleft calc_title">{row.data}<br/>{row.tytul}<br/>{row.od} </td>
                                                                            <td className="goright">
                                                                                Przelew:&nbsp;
                                                                                <FormatDecimal value={row.kwota} />
                                                                                <br/>
                                                                                Suma roz.: <FormatDecimal value={row.suma_sugerowanych} /> 
                                                                                <br/>
                                                                                {
                                                                                    pozostalo != 0 &&
                                                                                    <b className="amount_minus">Pozostało: <FormatDecimal value={ pozostalo} /> </b>
                                                                                }

                                                                                {
                                                                                    pozostalo == 0 &&
                                                                                    <b className="amount_plus">Pozostało: <FormatDecimal value={ pozostalo} /> </b>
                                                                                }
                                                                                
                                                                            </td>                                                                           
                                                                           

                                                                            <td>
                                                                           
                                                                                    <div>
                                                                                        <InputCombo items={kids} value={ row.p_dziecko_id } err={errTab}  valChange={valChangeListenerD} goNext={null} name={ ixRow } placeholder={""} className='  ' req='0'   /> 
                                                                                    </div>

                                                                                        {
                                                                                        row.p_dziecko_id > 0 &&     
                                                                                        <div>
                                                                                             <table className="table" >
                                                                                                <thead>
                                                                                                    <tr className="header">                                                                                                                                                                                                                                                                   
                                                                                                        <td>Rodzic</td>                                                                                                                                                                                                                                                                                                                                           
                                                                                                        <td> &nbsp; </td>                                                                                                                                                                                                                                                                                                       
                                                                                                    </tr>
                                                                                                </thead>

                                                                                                        {
                                                                                                            row.pozycje != null &&
                                                                                                            <tbody>
                                                                                                                
                                                                                                                {

                                                                                                            

                                                                                                                    row.pozycje.map( ( rodzic, inx) => {
                                                                                                                        
                                                                                                                        var info = null;

                                                                                                                        if(rodzic.prowadzenie_salda	 == 1)
                                                                                                                        {
                                                                                                                            info = <div>
                                                                                                                                <strong>(Odpowiedzialny za płatności)</strong> 
                                                                                                                                </div>
                                                                                                                        }

                                                                                                                        return <tr>
                                                                                                                                <td className="gocenter">{rodzic.imie} {rodzic.nazwisko}, (Saldo: <FormatDecimal value={rodzic.saldo}/> ) {info}</td>                                                                 
                                                                                                                                <td>
                                                                                                                                        <table className="table" >
                                                                                                                                            <thead>
                                                                                                                                                
                                                                                                                                            </thead>
                                                                                                                                            <tbody>
                                                                                                                                                {
                                                                                                                                                    rodzic.dzieci.map( (dziecko, dinx) => {

 

                                                                                                                                                        return <tr>
                                                                                                                                                                    <td className="gocenter">{dziecko.imie} {dziecko.nazwisko} (Saldo: <FormatDecimal value={dziecko.saldo}/> )</td>                                                                                                                                                                                                                                                                                                                                                                                                                                              
                                                                                                                                                                    <td>
                                                                                                                                                                        <div className="calc_scroll">
                                                                                                                                                                                <table className="table" >
                                                                                                                                                                                    <thead>
                                                                                                                                                                                        <tr className="header2">                                                                                                                                                                                                                                                                   
                                                                                                                                                                                            <td>Numer dok.</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                        
                                                                                                                                                                                            <td>Pozostało</td>                                                                                                                                                                                                                                                                                                       
                                                                                                                                                                                            <td>Kwota operacji</td>                                                                                                                                                                                                                                                                                                       
                                                                                                                                                                                        </tr>
                                                                                                                                                                                    </thead>
                                                                                                                                                                                    <tbody>

                                                                                                                                                                                        {
                                                                                                                                                                                            dziecko.zobowiazania.map( (poz, inp) => {


                                                                                                                                                                                            var inxKey = ixRow + "_#_" + rodzic.id + "@" + dziecko.id + "@" + poz.typ + "@" + poz.typ_id;   

                                                              
                                                                                                                                                                                                return <tr>
                                                                                                                                                                                                    <td>{poz.opis}</td>                                                                                                                             
                                                                                                                                                                                                    <td className="goright">    <FormatDecimal value= {poz.pozostalo}/>  </td>
                                                                                                                                                                                                    <td className="gocenter">                                                                                                                                        
                                                                                                                                                                                                            
                                                                                                                                                                                                                <InputDecimal   userData={props.userData} value={ poz.sugerowana_kwota } err={errTab}  valChange={valChangeListener2} goNext={goNextNew} name={  inxKey } placeholder={"Kwota:"} className='w100' req='0'   />    
                                                                                                                                                                                                    </td>
                                                                                                                                                                                                </tr>
                                                                                                                                                                                            } )
                                                                                                                                                                                        }

                                                                                                                                                                                     

                                                                                                                                                                                        <tr>
                                                                                                                                                                                            <td className="gobold">Łączna kwota wpłaty / zwrotu</td>
                                                                                                                                                                                            <td> - </td>
                                                                                                                                                                                            <td className="gocenter gobold">
                                                                                                                                                                                                <FormatDecimal value={ dziecko.suma_sugerowana_kwota  }/>
                                                                                                                                                                                            </td>
                                                                                                                                                                                        </tr>
 
 

                                                                                                                                                                                    </tbody>
                                                                                                                                                                                </table>
                                                                                                                                                                        </div>
                                                                                                                                                                    </td>  
                                                                                                                                                        </tr>
                                                                                                                                                    } )
                                                                                                                                                }
                                                                                                                                            </tbody>
                                                                                                                                        </table>
                                                                                                                                </td>
                                                                                                                        </tr>
                                                                                                                    }  )
                                                                                                                }

                                                                                                            </tbody>
                                                                                                        }
                                                                                            </table>
                                                                                        </div>
                                                                                        }

                                                                            </td>
                                                                        </tr>

                                                                    } )
                                                                }

                                                                </tbody>
                                                    </table>

                                            </div>
                                        }  
                                        

                                        {
                                            tab != null &&
                                            <div>
                                                        <div className="form_split"></div>

                                                        <div className="form_btn">
                                                                <div className="btn" onClick={saveData}>Dodaj</div>
                                                                &nbsp;
                                                                <div className="btn" onClick={onBack}>Anuluj</div>
                                                        </div>
                                            </div>  
                                        }
                                        
                                          

                    </form>


            </div>

}


export default TransferBank;